import { render, staticRenderFns } from "./MarkdownToolBox.vue?vue&type=template&id=5b63f889"
import script from "./MarkdownToolBox.vue?vue&type=script&lang=js"
export * from "./MarkdownToolBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports